// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tsDvt","placeholdersHeader":"styles_placeholdersHeader__JHKhj","editorStyle":"styles_editorStyle__1U7fk","placeholdersBox":"styles_placeholdersBox__3ivmo"};